<template>
  <div>
    <div v-show="!showUpdate" class="app-content content ">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
                name="Group"
                bc1="App"
                bc2="Group"
                bc3="List"
            ></Breadcrumb>
          </div>
        </div>
        <div class="content-body">
          <div class="card">
            <div class="m-2">
              <div class="row">
                <div class="col-md-6 mb-1 col-sm-12">
                  <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
                </div>
                <div class="col-md-6 mb-1 col-sm-12">
                  <button type="button" class="btn btn-primary"  @click="onSubmitFilters" >Search</button>
                  <button type="button" class="ml-1 btn btn-danger " @click="clear" >Clear</button>
                </div>
              </div>
            </div>
            <div class="m-2">
              <div class="row">
                <div class="col-md-12 col-12">
                  <div class="d-flex align-items-center justify-content-end">
                    <div class="col-sm-2">
                      <select class="form-control" v-model="selectedAccount">
                        <option :key="index" :value="item.id"   v-for="(item, index) in options">
                          {{ item.value }}
                        </option>
                      </select>
                    </div>
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="$router.push({ name: 'group-add' })"
                    >
                      <AddButtonText name="Group" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <CommonTableStore
                :url="url"
                :tableHeaderValues="tableHeaderValues"
                :filteredData="filteredData"
                :actions="actions"
                :deleteActions="deleteActions"
                :showPerPage = true
                :mutedData="mutedData"
                :storageKey="storageKey"
                :externalTotalRecord="externalTotalRecord"
                :actionDropdown="true"
            />

          </div>
        </div>
      </div>
    </div>
    <UpdateGroup @back="showUpdate = false" v-if="showUpdate"  />
  </div>
</template>

<script>


import UpdateGroup from "@/pages/dashboard/group/UpdateGroup.vue";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  components: {AddButtonText, UpdateGroup},

  mounted() {
    localStorage.setItem("url", "v1/get-group");
    this.checkDataInStore('v1/get-group')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      url: "v1/get-group",
      showUpdate:false,
      storageKey: "group",
      isDefault: false,
      renderComponent: true,
      selectedAccount : 2,
      type: 1,
      data: {
        // flag: "all",
        type: 1 },
      options: [
        { id: 2, value: "Merchant" },
        { id: 1, value: "User" }
      ],
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name",
          html: true,
          alter: function(value) {
            var html = `<span>${value}</span>`;


            return html;
          }
        },
        {
          title: "Code",
          valueKey: "code",
          html: true,
          alter: function(value) {
            var html = `<span class="text-info">${value}</span>`;


            return html;
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-glow badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-glow badge-sm">Inactive</span>`;
            }

            return html;
          }
        }
      ],
      actions: [
        {
          title: "Update",
          class: "btn btn-sm btn-primary badge",
          cta: (row, index) => {
            let data = {
              ...row,
              index: index,
              row: row,
              key: "groupsUpdate",
              storageKey: this.storageKey,
              idx: index,
            }
            this.$store.dispatch("set", data);
            this.showUpdate = true
          }
        },
        {
          title: "Manage Channel",
          class: "btn btn-sm btn-primary badge",
          conditionalRendering: true,
          condition: (row)=>{
            if(this.selectedAccount == 1 ){
              return false
            }
            return true
          },
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "groupsChannel"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "manage-group-channel" });
          }
        },
        {
          title: "Manage Stores",
          class: "btn btn-sm btn-primary badge",
          conditionalRendering: true,
          condition: (row)=>{
            if(this.selectedAccount == 1 ){
              return false
            }
            return true
          },
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "groupsStore"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "manage-group-store" });
          }
        },

      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "groupDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: "",
      filteredData: {type: 2},
      search: '',
    };
  },
  methods: {
    onSubmitFilters() {

      let filterData = {
        ...this.filteredData,
        search: ''
      }

      if(this.search != ''){
        filterData.search = this.search
      }

      this.filteredData = filterData

    },
    clear(){
      this.search = ''
      this.filteredData = Object.fromEntries(
          Object.entries(this.filteredData).filter(([key]) => key !== 'search')
      );
    },

    deleteRecord(data) {
      this.makeRequest("post", "v1/delete-group", {
        status: data.row.status == true ? 1 : 0,
        groupId: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey("groups");
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                  typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                  typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = "groups";
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  },
  watch: {
    selectedAccount(val) {
      this.filteredData = {type: val}
    }
  }
};
</script>
